import type { AdmissionPriceProps } from './calculate-booking-price.type';

export const calculateOfflinePrice = ({ offer, quantity }: AdmissionPriceProps) => {
  if (!offer) return 0;
  let number = 0;
  if (offer.price.offlinePrice) {
    number += offer.price.offlinePrice * quantity;
  }
  return number;
};
